import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const LoadMoreSentinel = styled.div.withConfig({ displayName: 'LoadMoreSentinel' })`
    width: 100%;
    height: 1px;
`;

export interface LoadMoreObserverProps {
    onLoadNext?: VoidFunction;
    disabled?: boolean;
    rootMargin?: string;
}

export function LoadMoreObserver({
    onLoadNext,
    disabled,
    rootMargin = '200px',
}: LoadMoreObserverProps) {
    const sentinelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!onLoadNext || disabled) {
            return;
        }

        const element = sentinelRef.current;

        if (!element) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0]?.isIntersecting) {
                    onLoadNext();
                }
            },
            { rootMargin },
        );

        observer.observe(element);

        return () => observer.disconnect();
    }, [onLoadNext, disabled, rootMargin]);

    return <LoadMoreSentinel ref={sentinelRef} />;
}
